// @flow
import type { OptionT } from "./misc/Types";

type getLabelT = (property: string, option: string) => string;

type Options = {
  [key: string]: string[],
};

type NormalizedOption = { [key: string]: OptionT[] };

export function normalizePropertyOptions(getLabel: getLabelT) {
  return function (property: string) {
    return function (options: string[]) {
      return options.map<{ value: any, text: string }>((option) => ({
        value: option,
        text: getLabel(property, option),
      }));
    };
  };
}

export function normalizeOptions(getLabel: getLabelT) {
  return function (options: Options): NormalizedOption {
    const normalizeOption = normalizePropertyOptions(getLabel);

    const normalizedOptions = Object.keys(options).reduce((normalized, option) => {
      normalized[option] = normalizeOption(option)(options[option]);
      return normalized;
    }, {});

    return normalizedOptions;
  };
}
